<template>
  <div style="background-color: #EEEEEE;">
    <!--
     :rotate="rotate"
         @password="password"
         @progress="loadedRatio = $event"
         @error="error"
         @num-pages="pageSize = $event"
         @link-clicked="pageNumber = $event"
     -->
    <el-row type="flex" justify="end" style="padding: 10px 10px;">
      <el-input-number v-model="innerPercentWidth" size="mini" :step="percentStep" :min="1" :max="500"></el-input-number>
    </el-row>
    <div :style="{height: height, 'overflow-y': 'auto'}">
      <div :style="{width: `${innerPercentWidth}%`, margin: '0 auto'}">
        <div style="padding-bottom: 20px;">
          <div v-for="i in pageSize" :key="i" style="padding-top: 10px;">
            <pdf style="display: inline-block; width: 100%"
                 :src="pdfSrc"
                 :page="i"
            ></pdf>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import pdf from 'vue-pdf'
  export default {
    name: "PDFViewer",
    components: {
      pdf
    },
    props: {
      percentWidth: {
        type: Number,
        default: 50,
        max: 100,
        min: 1
      },
      height: {
        type: String,
        default: '842px',
      },
      percentStep: {
        type: Number,
        default: 5,
      },
      url: {
        type: String,
      }
    },
    data() {
      return {
        innerPercentWidth: 100,
        pdfSrc: null,
        pageSize: 0,
      };
    },
    watch: {
      percentWidth: {
        immediate: true,
        handler(value) {
          this.innerPercentWidth = value;
        }
      },
      url: {
        immediate: true,
        handler(value) {
          if (value != null) {
            this.pdfSrc = pdf.createLoadingTask(value);
            this.pdfSrc.then((pdf) => {
              this.pageSize = pdf.numPages;
            }, (error) => {
              window.console.error(error);
            });
          }
        }
      }
    },
    methods: {
      rescale(val) {
        let innerPercentWidth = this.innerPercentWidth + val * this.percentStep;
        if (innerPercentWidth > 100) {
          innerPercentWidth = 100;
        }
        if (innerPercentWidth < 1) {
          innerPercentWidth = 1;
        }
        this.innerPercentWidth = innerPercentWidth;
      },
      error(err) {
        console.log(err);
      }
    },
    mounted() {

    }
  }
</script>

<style scoped>

</style>
